<template>
  <div>
    <div class="page-title">New Project Form</div>
    <Form btnText="Add Project" v-model="form" :submit="create" />
  </div>
</template>

<script>
import Form from "./_form.internal_projects.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.InternalProject.new();
      this.form = data;
    },
    async create() {
      await this.$api.InternalProject.create(this.form);
      this.$router.push("/internal_projects");
    },
  },
};
</script>

<style></style>
